import { accountBlocFactory } from './chunk-W663VKW4.mjs';
export { accountBlocFactory, accountOutputSchema as accountSchema } from './chunk-W663VKW4.mjs';
import { app } from './chunk-ABZ5OBXE.mjs';
import { getAuth } from 'firebase/auth';

var auth = getAuth(app);

// src/account.ts
var accountBloc = accountBlocFactory({ auth });

export { accountBloc };
//# sourceMappingURL=account.mjs.map
//# sourceMappingURL=account.mjs.map